


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { FormList } from './types';

@Component
export default class ComponentsCollapse extends Vue {
  @Prop({type: Array, required: true})
  list: FormList;

  flag: number = 0;

  get oneFormName() {
    const { list } = this;
    return list.length == 1 ? list[0].name : '';
  }

  showContent(index: number, id: number) {
    this.flag = index;
    this.$emit('formId', id);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/accordion/Accordion.vue